import AddTradeCommentTiptap from '@/components/trade/activity-feed/tip-tap-editor/add-trade-comment-tiptap';
import type { Audit, Comment } from '@/models/registry';
import type { AuditLog, Trade } from '@/models/types';
import { CommentsOrderBy } from '@/models/types';
import { toJS } from 'mobx';
import { useMemo } from 'react';
import { getCombinedAuditLogs } from '../../deal/activity-feed/combined-audit-line';
import AuditTrail from './audit-trail';

const ActivityFeed = ({
  audits = [],
  auditLogs = [],
  comments = [],
  tradeId,
  tradeShortId,
  orderBy,
}: {
  audits: Audit[];
  auditLogs: AuditLog[];
  comments: Comment[];
  tradeId: Trade['id'];
  tradeShortId: Trade['short_id'];
  orderBy: CommentsOrderBy;
}) => {
  const sortedAuditLogs = useMemo(() => {
    /* The auditLogs come in chronological order, so we need to reverse them if the orderBy is "oldest" */

    if (orderBy === CommentsOrderBy.Newest) {
      // reverse the auditLogs
      const reversedAuditLogs = [...auditLogs].reverse();
      return reversedAuditLogs;
    }

    return auditLogs;
  }, [toJS(auditLogs), orderBy]);

  const sortedLogsWithGroupedAudits = useMemo(() => {
    return getCombinedAuditLogs(sortedAuditLogs, audits);
  }, [sortedAuditLogs, audits]);

  if (orderBy === CommentsOrderBy.Newest) {
    return (
      <div className="flex flex-col gap-4">
        <AddTradeCommentTiptap tradeId={tradeId} />
        <AuditTrail
          auditLogs={sortedLogsWithGroupedAudits}
          audits={audits}
          comments={comments}
          tradeId={tradeId}
          tradeShortId={tradeShortId}
        />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <AuditTrail
        key={orderBy}
        auditLogs={sortedLogsWithGroupedAudits}
        audits={audits}
        comments={comments}
        tradeId={tradeId}
        tradeShortId={tradeShortId}
      />
      <AddTradeCommentTiptap tradeId={tradeId} />
    </div>
  );
};

export default ActivityFeed;
